import { MAX_SIZE_ALLOWED, MAX_SIZE_ALLOWED_MB } from "../constants/contants";

export const handleClickFile = (ref: any) => {
  ref.current?.click();
};

export const handleFileChange = (e: any, formik: any, setErrorLoad: any) => {
  if (e?.target?.name && e.target?.files[0]?.name && e.target.files && e.target.files[0].size > MAX_SIZE_ALLOWED) {
    setErrorLoad({
      state: true,
      text: `Error, el archivo supera los ${MAX_SIZE_ALLOWED_MB} MB`,
      reason: "size",
    });
    formik.setFieldValue(`${e.target.name}.file`, "");
    formik.setFieldValue(`${e.target.name}.attachedFile`, "");
  } else {
    setErrorLoad({
      state: false,
      text: "",
      reason: "",
    });
    formik.setFieldValue(`${e.target.name}.file`, e.target.files[0].name);
    formik.setFieldValue(`${e.target.name}.attachedFile`, e.target.files[0]);
  }
};

export const handleClickRemoveFile = (name: string, formik: any, ref: any) => {
  formik.setFieldValue(`${name}.file`, "");
  formik.setFieldValue(`${name}.attachedFile`, "");
  ref.current.value = "";
};

export const removeAllFiles = (name: string[], formik: any, ref: any[]) => {
  name.forEach((element, index) => {
    handleClickRemoveFile(element, formik, ref[index]);
  });
};
